import { Box, Divider, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { observer } from "mobx-react";
import { PanelContainer, ToolbarIcon } from "../Styles";

const CollapsiblePanel = ({ open, onToggle, children, menuActions, width, setWidth }) => {
  const handleMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = width;

    const handleMouseMove = (moveEvent) => {
      const newWidth = startWidth + (moveEvent.clientX - startX);
      setWidth(Math.max(150, newWidth));
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  return (
    <PanelContainer open={open} width={width}>
      <ToolbarIcon>
        {open && menuActions}
        <IconButton
          aria-label={open ? "Expand" : "Collapse"}
          onClick={onToggle}
        >
          {open ? <ChevronLeft /> : <ChevronRight />}
        </IconButton>
      </ToolbarIcon>
      {open && <Divider />}
      {open && (
        <Box sx={{ overflowY: "auto", flexGrow: 1, maxHeight: 3/4, marginRight:'8px' }}>
          {children}
        </Box>
      )}
      {open && (
        <Box
          onMouseDown={handleMouseDown}
          sx={{
            width: "5px",
            cursor: "col-resize",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 100,
            backgroundColor: "#f4f7f9",
          }}
        />
      )}

    </PanelContainer>
  );
};

export default observer(CollapsiblePanel);